/**
 * Language constants shared between server and client components.
 * Extracted from LanguageContext to avoid 'use client' boundary issues.
 */

export const LANGS = ['ja', 'en', 'ko', 'zh', 'es', 'fr', 'de', 'pt'] as const;
export type Lang = (typeof LANGS)[number];

export const LANG_LABELS: Record<Lang, string> = {
  ja: '日本語',
  en: 'English',
  ko: '한국어',
  zh: '中文',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  pt: 'Português',
};

export const DEFAULT_LANG: Lang = 'ja';
